/**
 * @desc 获取实例历史变量
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<ObjectMap<string, ObjectMap>>;
export function request(
  params: API.activiti.business.historyInstanceVariable.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/business/historyInstanceVariable`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
